export const ROOM_DETAIL_QUERY = 'viewRoomDetail';
export const PLAN_DETAIL_QUERY = 'viewPlanDetail';
